import { getItemsArray } from '../../../util/prop_utils'
import { tagsToOptions } from '../tag_select'

function filterTagsByTeam(tags, teamId, personalTeamId) {
    if (!teamId && teamId !== 0) return tags
    return tags.filter(tag => tag.teamId === teamId || tag.teamId === personalTeamId)
}

function getFirstTeamTag(tags, personalTeamId) {
    return tags.find(tag => !!tag.teamId && tag.teamId !== personalTeamId) || {}
}

const getFirstExpiredTeam = (tags, teams, personalTeamId) => {
    // get the tag
    const t =
        tags.find(tag => {
            const team = teams[tag.teamId]
            return (
                !!tag.teamId &&
                tag.teamId !== personalTeamId &&
                team.trialEnd &&
                new Date(team.trialEnd) < new Date()
            )
        }) || null
    // return the team or null
    return (t && teams[t.teamId]) || null
}

function getFilteredTagsArray(sourceTags, selectedTags=[], personalTeamId) {
    const tagArray = getItemsArray(sourceTags)
    const teamTag = getFirstTeamTag(selectedTags, personalTeamId)
    return filterTagsByTeam(tagArray, teamTag.teamId, personalTeamId)
}

function getTagsAsOptions(ids, tagMap, teams) {
    const tagArr = ids.map(id => tagMap[id])
    return tagsToOptions(tagArr, teams)
}

export {
    getFirstTeamTag,
    getFilteredTagsArray,
    getTagsAsOptions,
    getFirstExpiredTeam,
}


// WEBPACK FOOTER //
// ./src/common/components/modals/time_entry_modal.js